export const getTagManager = () => {
    window.dataLayer = window.dataLayer || [];
    const pushTagManagerEvent = (eventType, variables) => window.dataLayer.push(Object.assign({ event: eventType }, (variables || {})));
    return {
        pushTagManagerEvent,
    };
};
